import { useEffect } from 'react'
import { useDisplayMode } from '../lib/displayMode'

// Compact two-segment toggle: Gross | Adjusted. Shared style so the two
// surfaces it renders on (in-round scoring + round leaderboard) look
// visually identical.
//
// `available` gates the whole toggle. When false, we can't compute a
// meaningful "Adjusted" number (at least one player has no round-start
// handicap) — hide the toggle entirely and force the mode back to Gross
// so downstream cells don't render a bogus adjusted number.
export default function DisplayModeToggle({ style, available = true }) {
  const [mode, setMode] = useDisplayMode()

  useEffect(() => {
    if (!available && mode !== 'gross') setMode('gross')
  }, [available, mode, setMode])

  if (!available) return null

  const seg = (label, val) => (
    <button
      type="button"
      onClick={() => setMode(val)}
      style={{
        padding: '4px 12px',
        border: 'none',
        borderRadius: 6,
        background: mode === val ? 'var(--gold)' : 'transparent',
        color: mode === val ? 'var(--green-deep)' : 'var(--gray-300)',
        fontFamily: 'var(--font-body)',
        fontSize: '0.72rem',
        fontWeight: 700,
        cursor: 'pointer',
        letterSpacing: '0.03em',
      }}
    >
      {label}
    </button>
  )
  return (
    <div
      style={{
        display: 'inline-flex',
        gap: 2,
        padding: 2,
        borderRadius: 8,
        background: 'var(--green-deep)',
        border: '1px solid var(--green-mid)',
        ...style,
      }}
    >
      {seg('Gross', 'gross')}
      {seg('Adjusted', 'adjusted')}
    </div>
  )
}
